(() => {
  if (window.__joansA0PurchaseLoaded) {
    return;
  }

  window.__joansA0PurchaseLoaded = true;

  function parseInteger(value) {
    return Number.parseInt(value || "", 10);
  }

  function createToken() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID === "function"
    ) {
      return window.crypto.randomUUID();
    }

    return [
      Date.now(),
      Math.random().toString(36).slice(2, 10),
    ].join("-");
  }

  function sanitiseFileName(fileName) {
    const normalisedName =
      typeof fileName.normalize === "function"
        ? fileName.normalize("NFKD")
        : fileName;

    return normalisedName
      .replace(/[^\w.\-]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
      .slice(-150);
  }

  function isPdf(file) {
    return (
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf")
    );
  }

  function initialisePanels(root = document) {
    const panels = [];

    if (
      root instanceof Element &&
      root.matches("[data-joans-a0-purchase]")
    ) {
      panels.push(root);
    }

    if (typeof root.querySelectorAll === "function") {
      panels.push(
        ...root.querySelectorAll(
          "[data-joans-a0-purchase]"
        )
      );
    }

    panels.forEach((panel) => {
      initialisePanel(panel);
    });
  }

  function initialisePanel(panel) {
    if (
      panel.dataset.joansA0Initialised === "true"
    ) {
      return;
    }

    const productForm = panel.closest("form");

    const productFormComponent =
      productForm?.closest(
        "product-form-component"
      );

    const productId =
      productFormComponent?.dataset.productId || "";

    let nativeQuantity =
  productForm?.querySelector(
    'input[name="quantity"]'
  );

if (!nativeQuantity && productForm) {
  nativeQuantity =
    document.createElement("input");

  nativeQuantity.type = "hidden";
  nativeQuantity.name = "quantity";
  nativeQuantity.value = "1";

  productForm.appendChild(
    nativeQuantity
  );
}

    const a0VariantId = parseInteger(
      panel.dataset.a0VariantId
    );

    const a0Price = parseInteger(
      panel.dataset.a0Price
    );

    const bookletVariantId = parseInteger(
      panel.dataset.bookletVariantId
    );

    const bookletPrice = parseInteger(
      panel.dataset.bookletPrice
    );

    const envelopeVariantId = parseInteger(
      panel.dataset.envelopeVariantId
    );

    const envelopePrice = parseInteger(
      panel.dataset.envelopePrice
    );

    const bookletAvailable =
      panel.dataset.bookletAvailable === "true";

    const envelopeAvailable =
      panel.dataset.envelopeAvailable === "true";

    const currency =
      panel.dataset.currency || "NZD";

    const locale =
      panel.dataset.locale || "en-NZ";

    const supabaseUrl =
      panel.dataset.supabaseUrl || "";

    const supabaseKey =
      panel.dataset.supabaseKey || "";

    const supabaseBucket =
      panel.dataset.supabaseBucket || "";

    const supabaseFolder =
      panel.dataset.supabaseFolder || "joans-a0";
     
    const mode =
    panel.dataset.joansA0Mode || "standard";

   const isComplimentary =
   mode === "complimentary";

    const patternInput = panel.querySelector(
      "[data-joans-a0-pattern-files]"
    );

    const instructionInput =
      panel.querySelector(
        "[data-joans-a0-instruction-files]"
      );

    const patternList = panel.querySelector(
      "[data-joans-a0-pattern-list]"
    );

    const instructionList =
      panel.querySelector(
        "[data-joans-a0-instruction-list]"
      );

    const patternMessage =
      panel.querySelector(
        "[data-joans-a0-pattern-message]"
      );

    const instructionMessage =
      panel.querySelector(
        "[data-joans-a0-instruction-message]"
      );

    const cartMessage = panel.querySelector(
      "[data-joans-a0-cart-message]"
    );

    const patternProgress =
      panel.querySelector(
        "[data-joans-a0-pattern-progress]"
      );

    const patternProgressBar =
      panel.querySelector(
        "[data-joans-a0-pattern-progress-bar]"
      );

    const instructionProgress =
      panel.querySelector(
        "[data-joans-a0-instruction-progress]"
      );

    const instructionProgressBar =
      panel.querySelector(
        "[data-joans-a0-instruction-progress-bar]"
      );

    const patternUploadLabel =
      panel.querySelector(
        "[data-joans-a0-upload-label]"
      );

    const instructionUploadLabel =
      panel.querySelector(
        "[data-joans-a0-instruction-upload-label]"
      );

    const a0Minus = panel.querySelector(
      "[data-joans-a0-minus]"
    );

    const a0Plus = panel.querySelector(
      "[data-joans-a0-plus]"
    );

    const a0QuantityDisplay =
      panel.querySelector(
        "[data-joans-a0-quantity]"
      );

    const bookletCheckbox =
      panel.querySelector(
        "[data-joans-a0-booklet]"
      );

    const bookletCard = panel.querySelector(
      "[data-joans-a0-booklet-card]"
    );

    const bookletContent =
      panel.querySelector(
        "[data-joans-a0-booklet-content]"
      );

    const bookletMinus =
      panel.querySelector(
        "[data-joans-a0-booklet-minus]"
      );

    const bookletPlus =
      panel.querySelector(
        "[data-joans-a0-booklet-plus]"
      );

    const bookletQuantityDisplay =
      panel.querySelector(
        "[data-joans-a0-booklet-quantity]"
      );

    const envelopeCheckbox =
      panel.querySelector(
        "[data-joans-a0-envelope]"
      );

    const envelopeCard = panel.querySelector(
      "[data-joans-a0-envelope-card]"
    );

    const envelopeContent =
      panel.querySelector(
        "[data-joans-a0-envelope-content]"
      );

    const envelopeMinus =
      panel.querySelector(
        "[data-joans-a0-envelope-minus]"
      );

    const envelopePlus =
      panel.querySelector(
        "[data-joans-a0-envelope-plus]"
      );

    const envelopeQuantityDisplay =
      panel.querySelector(
        "[data-joans-a0-envelope-quantity]"
      );

    const totalDisplay = panel.querySelector(
      "[data-joans-a0-total]"
    );

    const a0Breakdown = panel.querySelector(
      "[data-joans-a0-a0-breakdown]"
    );

    const bookletBreakdown =
      panel.querySelector(
        "[data-joans-a0-booklet-breakdown]"
      );

    const envelopeBreakdown =
      panel.querySelector(
        "[data-joans-a0-envelope-breakdown]"
      );

    const notesWrapper = panel.querySelector(
      "[data-joans-a0-notes]"
    );

    const notesToggle = panel.querySelector(
      "[data-joans-a0-notes-toggle]"
    );

    const notesContent = panel.querySelector(
      "[data-joans-a0-notes-content]"
    );

    const notesMark =
      notesToggle?.querySelector(
        ".joans-a0-purchase__notes-mark"
      );

    const notesInput = panel.querySelector(
      "[data-joans-a0-print-notes]"
    );

    const relatedOrderInput =
  panel.querySelector(
    "[data-joans-a0-related-order]"
  );

    const addButton = panel.querySelector(
      "[data-joans-a0-add]"
    );

    const openHelpButton =
      panel.querySelector(
        "[data-joans-a0-open-help]"
      );

    const closeHelpButton =
      panel.querySelector(
        "[data-joans-a0-close-help]"
      );

    const helpModal = panel.querySelector(
      "[data-joans-a0-modal]"
    );

    if (
      !productForm ||
      !nativeQuantity ||
      Number.isNaN(a0VariantId) ||
      Number.isNaN(a0Price) ||
      !patternInput ||
      !instructionInput ||
      !patternList ||
      !instructionList ||
      !patternMessage ||
      !instructionMessage ||
      !cartMessage ||
      !patternProgress ||
      !patternProgressBar ||
      !instructionProgress ||
      !instructionProgressBar ||
      !patternUploadLabel ||
      !instructionUploadLabel ||
      !a0Minus ||
      !a0Plus ||
      !a0QuantityDisplay ||
      !bookletCheckbox ||
      !bookletCard ||
      !bookletContent ||
      !bookletMinus ||
      !bookletPlus ||
      !bookletQuantityDisplay ||
      !envelopeCheckbox ||
      !envelopeCard ||
      !envelopeContent ||
      !envelopeMinus ||
      !envelopePlus ||
      !envelopeQuantityDisplay ||
      !totalDisplay ||
      !a0Breakdown ||
      !bookletBreakdown ||
      !envelopeBreakdown ||
      !notesWrapper ||
      !notesToggle ||
      !notesContent ||
      !notesInput ||
      !addButton ||
      !openHelpButton ||
      !closeHelpButton ||
      !helpModal
    ) {
      console.error(
        "Joan's: A0 purchase panel data not found"
      );

      return;
    }

    if (
      !supabaseUrl ||
      !supabaseKey ||
      !supabaseBucket
    ) {
      patternMessage.textContent =
        "The file uploader is not configured.";

      patternMessage.classList.add(
        "is-error"
      );

      console.error(
        "Joan's: Supabase configuration is missing"
      );

      return;
    }

    panel.dataset.joansA0Initialised =
      "true";

    productForm.classList.add(
      "joans-a0-form--enhanced"
    );

    let supabaseClientPromise = null;

    function getSupabaseClient() {
      if (supabaseClientPromise) {
        return supabaseClientPromise;
      }

      supabaseClientPromise =
        new Promise((resolve, reject) => {
          const startedAt = Date.now();

          function checkForClient() {
            if (
              window.supabase &&
              typeof window.supabase
                .createClient === "function"
            ) {
              resolve(
                window.supabase.createClient(
                  supabaseUrl,
                  supabaseKey,
                  {
                    auth: {
                      persistSession: false,
                      autoRefreshToken: false,
                      detectSessionInUrl: false,
                    },
                  }
                )
              );

              return;
            }

            if (
              Date.now() - startedAt >=
              10000
            ) {
              reject(
                new Error(
                  "The file uploader did not load. Please refresh the page."
                )
              );

              return;
            }

            window.setTimeout(
              checkForClient,
              100
            );
          }

          checkForClient();
        });

      return supabaseClientPromise;
    }

    const orderToken = createToken();

    let a0Quantity = 1;
    let bookletQuantity = 1;
    let envelopeQuantity = 1;

    let patternFiles = [];
    let instructionFiles = [];

    let patternUploadInProgress = false;
    let instructionUploadInProgress =
      false;

    let isAdding = false;

    function formatMoney(cents) {
      return new Intl.NumberFormat(
        locale,
        {
          style: "currency",
          currency,
        }
      ).format(cents / 100);
    }

    function notifyNativeQuantity() {
      nativeQuantity.dispatchEvent(
        new Event("input", {
          bubbles: true,
        })
      );

      nativeQuantity.dispatchEvent(
        new Event("change", {
          bubbles: true,
        })
      );
    }

    function setNativeQuantity(quantity) {
      nativeQuantity.value =
        String(quantity);

      notifyNativeQuantity();
    }

    function setMessage(
      element,
      message,
      isError = false
    ) {
      element.textContent = message;

      element.classList.toggle(
        "is-error",
        isError
      );
    }

    function setProgress(
      wrapper,
      bar,
      value,
      visible
    ) {
      wrapper.hidden = !visible;

      bar.style.width = `${Math.max(
        0,
        Math.min(100, value)
      )}%`;
    }

    function renderFiles(container, files, type) {
  container.innerHTML = "";

  files.forEach((file, index) => {
    const row = document.createElement("div");
    row.className =
      "joans-a0-purchase__file-row";

    const name = document.createElement("span");
    name.className =
      "joans-a0-purchase__file-name";
    name.textContent = file.name;

    const actions = document.createElement("span");
    actions.className =
      "joans-a0-purchase__file-actions";

    const state = document.createElement("span");
    state.className =
      "joans-a0-purchase__file-state";
    state.textContent = "Uploaded ✓";

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className =
      "joans-a0-purchase__file-remove";
    removeButton.textContent = "Remove";
    removeButton.setAttribute(
      "aria-label",
      `Remove ${file.name}`
    );

    removeButton.addEventListener("click", () => {
      removeUploadedFile(type, index);
    });

    actions.append(state, removeButton);
    row.append(name, actions);
    container.appendChild(row);
  });
}

function removeUploadedFile(type, index) {
  if (type === "patterns") {
    patternFiles.splice(index, 1);

    renderFiles(
      patternList,
      patternFiles,
      "patterns"
    );

    patternInput.value = "";

    if (patternFiles.length) {
      setMessage(
        patternMessage,
        `${patternFiles.length} ${
          patternFiles.length === 1 ? "file" : "files"
        } ready.`
      );
    } else {
      setMessage(patternMessage, "");
      patternUploadLabel.textContent =
        "Choose PDF files";
    }
  }

  if (type === "instructions") {
    instructionFiles.splice(index, 1);

    renderFiles(
      instructionList,
      instructionFiles,
      "instructions"
    );

    if (instructionInput) {
      instructionInput.value = "";
    }

    if (instructionFiles.length) {
      setMessage(
        instructionMessage,
        `${instructionFiles.length} ${
          instructionFiles.length === 1 ? "file" : "files"
        } ready.`
      );
    } else {
      setMessage(instructionMessage, "");

      if (instructionUploadLabel) {
        instructionUploadLabel.textContent =
          "Choose instruction PDFs";
      }
    }
  }

  updateAddButton();
}

    async function uploadFiles({
      files,
      type,
      list,
      message,
      progress,
      progressBar,
      uploadLabel,
    }) {
      const selectedFiles =
        Array.from(files || []);

      if (!selectedFiles.length) {
        return [];
      }

      const invalidFile =
        selectedFiles.find(
          (file) => !isPdf(file)
        );

      if (invalidFile) {
        setMessage(
          message,
          `${invalidFile.name} is not a PDF file.`,
          true
        );

        return [];
      }

      list.innerHTML = "";

      setMessage(
        message,
        "Uploading files…"
      );

      setProgress(
        progress,
        progressBar,
        0,
        true
      );

      uploadLabel.textContent =
        "Uploading…";

      let supabaseClient;

      try {
        supabaseClient =
          await getSupabaseClient();
      } catch (error) {
        console.error(
          "Joan's: Supabase client did not load",
          error
        );

        setMessage(
          message,
          error instanceof Error
            ? error.message
            : "The file uploader did not load. Please refresh the page.",
          true
        );

        setProgress(
          progress,
          progressBar,
          0,
          false
        );

        uploadLabel.textContent =
          type === "patterns"
            ? "Choose PDF files"
            : "Choose instruction PDFs";

        return [];
      }

      const batchToken = createToken();
      const uploaded = [];

      for (
        let index = 0;
        index < selectedFiles.length;
        index += 1
      ) {
        const file =
          selectedFiles[index];

        const safeName =
          sanitiseFileName(file.name) ||
          `pattern-${index + 1}.pdf`;

        const path = [
          supabaseFolder,
          type,
          orderToken,
          batchToken,
          `${String(index + 1).padStart(
            2,
            "0"
          )}-${safeName}`,
        ].join("/");

        const { error } =
          await supabaseClient.storage
            .from(supabaseBucket)
            .upload(path, file, {
              cacheControl: "3600",
              contentType:
                "application/pdf",
              upsert: false,
            });

        if (error) {
          console.error(
            "Joan's: file upload failed",
            error
          );

          setMessage(
            message,
            `${file.name} could not be uploaded. Please choose the files again.`,
            true
          );

          setProgress(
            progress,
            progressBar,
            0,
            false
          );

          uploadLabel.textContent =
            type === "patterns"
              ? "Choose PDF files"
              : "Choose instruction PDFs";

          return [];
        }

        const { data } =
          supabaseClient.storage
            .from(supabaseBucket)
            .getPublicUrl(path);

        if (!data?.publicUrl) {
          setMessage(
            message,
            `${file.name} uploaded, but its link could not be created. Please choose the files again.`,
            true
          );

          setProgress(
            progress,
            progressBar,
            0,
            false
          );

          uploadLabel.textContent =
            type === "patterns"
              ? "Choose PDF files"
              : "Choose instruction PDFs";

          return [];
        }

        uploaded.push({
          name: file.name,
          url: data.publicUrl,
        });

        const percentage =
          Math.round(
            ((index + 1) /
              selectedFiles.length) *
              100
          );

        setProgress(
          progress,
          progressBar,
          percentage,
          true
        );
      }

      renderFiles(list, uploaded, type);

      setMessage(
        message,
        `${uploaded.length} ${
          uploaded.length === 1
            ? "file"
            : "files"
        } uploaded successfully.`
      );

      uploadLabel.textContent =
        type === "patterns"
          ? "Choose different PDF files"
          : "Choose different instruction PDFs";

      window.setTimeout(() => {
        setProgress(
          progress,
          progressBar,
          100,
          false
        );
      }, 500);

      return uploaded;
    }

    function getBookletSelected() {
  return (
    !isComplimentary &&
    bookletAvailable &&
    bookletCheckbox.checked
  );
}

function getEnvelopeSelected() {
  return (
    !isComplimentary &&
    envelopeAvailable &&
    envelopeCheckbox.checked
  );
}

    function updateExtras() {
      const bookletSelected =
        getBookletSelected();

      const envelopeSelected =
        getEnvelopeSelected();

      bookletCard.classList.toggle(
        "is-selected",
        bookletSelected
      );

      bookletContent.hidden =
        !bookletSelected;

      envelopeCard.classList.toggle(
        "is-selected",
        envelopeSelected
      );

      envelopeContent.hidden =
        !envelopeSelected;

      bookletBreakdown.hidden =
        !bookletSelected;

      bookletBreakdown.textContent =
        bookletSelected
          ? `${bookletQuantity} instruction ${
              bookletQuantity === 1
                ? "booklet"
                : "booklets"
            }`
          : "";

      envelopeBreakdown.hidden =
        !envelopeSelected;

      envelopeBreakdown.textContent =
        envelopeSelected
          ? `${envelopeQuantity} storage ${
              envelopeQuantity === 1
                ? "envelope"
                : "envelopes"
            }`
          : "";
    }

    function updateAddButton() {
  const bookletNeedsFiles =
    getBookletSelected() &&
    instructionFiles.length < 1;

  const uploading =
    patternUploadInProgress ||
    instructionUploadInProgress;

  const canAdd =
    patternFiles.length > 0 &&
    !bookletNeedsFiles &&
    !uploading &&
    !isAdding;

  addButton.disabled = !canAdd;

  if (isAdding) {
    addButton.textContent =
      "Adding…";
  } else if (uploading) {
    addButton.textContent =
      "Please wait for uploads to finish";
  } else if (
    patternFiles.length < 1
  ) {
    addButton.textContent =
      "Upload your PDF files to continue";
  } else if (bookletNeedsFiles) {
    addButton.textContent =
      "Upload the instruction PDF to continue";
  } else if (isComplimentary) {
    addButton.textContent =
      "Add complimentary print";
  } else {
    addButton.textContent =
      "Add print order to cart";
  }
}

    function updateDisplay() {
      setNativeQuantity(a0Quantity);

      a0QuantityDisplay.textContent =
        String(a0Quantity);

      bookletQuantityDisplay.textContent =
        String(bookletQuantity);

      envelopeQuantityDisplay.textContent =
        String(envelopeQuantity);

      a0Breakdown.textContent =
        `${a0Quantity} A0 ${
          a0Quantity === 1
            ? "page"
            : "pages"
        }`;

      updateExtras();

      const total =
        a0Quantity * a0Price +
        (getBookletSelected()
          ? bookletQuantity *
            bookletPrice
          : 0) +
        (getEnvelopeSelected()
          ? envelopeQuantity *
            envelopePrice
          : 0);

      totalDisplay.textContent =
        formatMoney(total);

      updateAddButton();
    }

    function changeQuantity(
      kind,
      amount
    ) {
      if (kind === "a0") {
        a0Quantity = Math.max(
          1,
          a0Quantity + amount
        );
      }

      if (kind === "booklet") {
        bookletQuantity = Math.max(
          1,
          bookletQuantity + amount
        );
      }

      if (kind === "envelope") {
        envelopeQuantity = Math.max(
          1,
          envelopeQuantity + amount
        );
      }

      updateDisplay();
    }

    function propertiesToAttributes(
      properties
    ) {
      return Object.entries(
        properties
      ).map(([key, value]) => ({
        key,
        value: String(value),
      }));
    }

    function makeProperties({
      files,
      prefix,
      notes,
      pageCount,
    }) {
      const properties = {
        "_Joans print order":
          orderToken,
      };

      if (pageCount) {
        properties["A0 page count"] =
          String(pageCount);
      }

   files.forEach((file, index) => {
  const fileNumber = index + 1;

  // Customer sees the filename only
  properties[`${prefix} ${fileNumber}`] = file.name;

  // Shopify keeps the full URL privately for us
  properties[`_${prefix} URL ${fileNumber}`] = file.url;
});
      if (notes) {
        properties["Print notes"] =
          notes;
      }

      return properties;
    }

    function buildLines() {
  const notes =
    notesInput.value.trim();

  const relatedOrder =
    relatedOrderInput?.value.trim() || "";

  const mainProperties =
    makeProperties({
      files: patternFiles,
      prefix: "Uploaded A0 File",
      notes,
      pageCount: isComplimentary
        ? null
        : a0Quantity,
    });

  if (isComplimentary) {
    mainProperties[
      "_Subscriber offer"
    ] = "Complimentary A0 pattern print";

    if (relatedOrder) {
      mainProperties[
        "Related order number"
      ] = relatedOrder;
    }
  }

  const lines = [
    {
      variantId: a0VariantId,

      quantity: isComplimentary
        ? 1
        : a0Quantity,

      properties: mainProperties,
    },
  ];

  if (getBookletSelected()) {
    if (
      Number.isNaN(
        bookletVariantId
      ) ||
      Number.isNaN(bookletPrice)
    ) {
      throw new Error(
        "The instruction booklet is not configured correctly."
      );
    }

    lines.push({
      variantId:
        bookletVariantId,

      quantity:
        bookletQuantity,

      properties: makeProperties({
        files:
          instructionFiles,
        prefix:
          "Instruction File",
        notes,
      }),
    });
  }

  if (getEnvelopeSelected()) {
    if (
      Number.isNaN(
        envelopeVariantId
      ) ||
      Number.isNaN(envelopePrice)
    ) {
      throw new Error(
        "The storage envelope is not configured correctly."
      );
    }

    lines.push({
      variantId:
        envelopeVariantId,

      quantity:
        envelopeQuantity,

      properties: {
        "_Joans print order":
          orderToken,
      },
    });
  }

  return lines;
}

    async function addUsingHorizon(
      lines
    ) {
      const updateCart =
        window.Shopify?.actions
          ?.updateCart;

      const openCart =
        window.Shopify?.actions
          ?.openCart;

      if (
        typeof updateCart !==
          "function" ||
        typeof openCart !==
          "function"
      ) {
        return false;
      }

      const result =
        await updateCart(
          {
            lines: lines.map(
              (line) => ({
                merchandiseId:
                  String(
                    line.variantId
                  ),

                quantity:
                  line.quantity,

                attributes:
                  propertiesToAttributes(
                    line.properties
                  ),
              })
            ),
          },
          {
            event: {
              context: "product",

              detail: {
                source:
  isComplimentary
    ? "joans-complimentary-a0"
    : "joans-a0-printing",

                productId,
              },
            },
          }
        );

      if (
        result?.userErrors?.length
      ) {
        throw new Error(
          result.userErrors[0]
            .message ||
            "The print order could not be added."
        );
      }

      if (result?.warnings?.length) {
        console.warn(
          "Joan's: A0 cart warning",
          result.warnings
        );
      }

      await openCart();

      return true;
    }

    async function addUsingAjax(
      lines
    ) {
      const cartRoot =
        window.Shopify?.routes
          ?.root || "/";

      const response = await fetch(
        `${cartRoot}cart/add.js`,
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",

            Accept:
              "application/json",
          },

          credentials:
            "same-origin",

          body: JSON.stringify({
            items: lines.map(
              (line) => ({
                id: line.variantId,

                quantity:
                  line.quantity,

                properties:
                  line.properties,
              })
            ),
          }),
        }
      );

      const data =
        await response.json();

      if (
        !response.ok ||
        data.status
      ) {
        throw new Error(
          data.description ||
            data.message ||
            "The print order could not be added."
        );
      }

      const openCart =
        window.Shopify?.actions
          ?.openCart;

      if (
        typeof openCart ===
        "function"
      ) {
        await openCart();
      } else {
        window.location.assign(
          `${cartRoot}cart`
        );
      }
    }

    async function addOrder() {
      if (
        addButton.disabled ||
        isAdding
      ) {
        return;
      }

      isAdding = true;

      setMessage(
        cartMessage,
        ""
      );

      updateAddButton();

      try {
        const lines = buildLines();

        const usedHorizon =
          await addUsingHorizon(
            lines
          );

        if (!usedHorizon) {
          await addUsingAjax(lines);
        }

        setMessage(
  cartMessage,
  isComplimentary
    ? "Your complimentary print has been added to the cart."
    : "Your print order has been added to the cart."
);

        addButton.textContent =
          "Added to cart";

        window.setTimeout(() => {
          isAdding = false;
          updateAddButton();
        }, 1400);
      } catch (error) {
        console.error(
          "Joan's: A0 print order failed",
          error
        );

        isAdding = false;

        setMessage(
          cartMessage,
          error instanceof Error
            ? error.message
            : "The print order could not be added. Please try again.",
          true
        );

        updateAddButton();
      }
    }

    function openHelp() {
      helpModal.hidden = false;

      document.body.classList.add(
        "joans-a0-modal-open"
      );

      closeHelpButton.focus();
    }

    function closeHelp() {
      helpModal.hidden = true;

      document.body.classList.remove(
        "joans-a0-modal-open"
      );

      openHelpButton.focus();
    }

    patternInput.addEventListener(
      "change",
      async () => {
        const selectedFiles =
          Array.from(
            patternInput.files || []
          );

        patternUploadInProgress =
          true;

        patternFiles = [];

        updateAddButton();

        patternFiles =
          await uploadFiles({
            files: selectedFiles,
            type: "patterns",
            list: patternList,
            message: patternMessage,
            progress:
              patternProgress,
            progressBar:
              patternProgressBar,
            uploadLabel:
              patternUploadLabel,
          });

        patternInput.value = "";

        patternUploadInProgress =
          false;

        updateAddButton();
      }
    );

    instructionInput.addEventListener(
      "change",
      async () => {
        const selectedFiles =
          Array.from(
            instructionInput.files ||
              []
          );

        instructionUploadInProgress =
          true;

        instructionFiles = [];

        updateAddButton();

        instructionFiles =
          await uploadFiles({
            files: selectedFiles,
            type: "instructions",
            list: instructionList,
            message:
              instructionMessage,
            progress:
              instructionProgress,
            progressBar:
              instructionProgressBar,
            uploadLabel:
              instructionUploadLabel,
          });

        instructionInput.value = "";

        instructionUploadInProgress =
          false;

        updateAddButton();
      }
    );

    a0Minus.addEventListener(
      "click",
      () => {
        changeQuantity(
          "a0",
          -1
        );
      }
    );

    a0Plus.addEventListener(
      "click",
      () => {
        changeQuantity(
          "a0",
          1
        );
      }
    );

    bookletMinus.addEventListener(
      "click",
      () => {
        changeQuantity(
          "booklet",
          -1
        );
      }
    );

    bookletPlus.addEventListener(
      "click",
      () => {
        changeQuantity(
          "booklet",
          1
        );
      }
    );

    envelopeMinus.addEventListener(
      "click",
      () => {
        changeQuantity(
          "envelope",
          -1
        );
      }
    );

    envelopePlus.addEventListener(
      "click",
      () => {
        changeQuantity(
          "envelope",
          1
        );
      }
    );

    bookletCheckbox.addEventListener(
      "change",
      updateDisplay
    );

    envelopeCheckbox.addEventListener(
      "change",
      updateDisplay
    );

    notesToggle.addEventListener(
      "click",
      () => {
        const isOpen =
          notesContent.hidden;

        notesContent.hidden =
          !isOpen;

        notesWrapper.classList.toggle(
          "is-open",
          isOpen
        );

        notesToggle.setAttribute(
          "aria-expanded",
          String(isOpen)
        );

        if (notesMark) {
          notesMark.textContent =
            isOpen ? "−" : "+";
        }
      }
    );

    addButton.addEventListener(
      "click",
      addOrder
    );

    openHelpButton.addEventListener(
      "click",
      openHelp
    );

    closeHelpButton.addEventListener(
      "click",
      closeHelp
    );

    helpModal.addEventListener(
      "click",
      (event) => {
        if (
          event.target === helpModal
        ) {
          closeHelp();
        }
      }
    );

    document.addEventListener(
      "keydown",
      (event) => {
        if (
          event.key === "Escape" &&
          !helpModal.hidden
        ) {
          closeHelp();
        }
      }
    );

    updateDisplay();
  }

  if (
    document.readyState === "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        initialisePanels();
      }
    );
  } else {
    initialisePanels();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initialisePanels(event.target);
    }
  );
})();